import { types } from '../../types';

const setGetGroupsAction = (payload) => {
  return {
    type: types.jackpot.SET_LIST_GROUP,
    payload,
  }
}

const setGetJackpotListAction = (payload) => {
  return {
    type: types.jackpot.SET_LIST_JACKPOT,
    payload
  }
}

const setGetJackpotViewAction = (payload) => {
  return {
    type: types.jackpot.SET_VIEW_JACKPOT,
    payload
  }
}

const setGetGroupJackpotAction = (payload) => {
  return {
    type: types.jackpot.SET_LIST_GROUP_JACKPOT,
    payload
  }
}

export {
  setGetGroupsAction as SetGetGroupsAction,
  setGetJackpotListAction as SetGetJackpotListAction,
  setGetJackpotViewAction as SetGetJackpotViewAction,
  setGetGroupJackpotAction as SetGetGroupJackpotAction
}